import React, { useMemo } from 'react';
import { Badge, Button, Col, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import MightyBucksGiftCardPage from '../../../features/products/MightyBucksGiftCardPage';
import { useSelector } from 'react-redux';
import { selectGeneralOptions, selectIsMobileRoute } from '../../../features/mobile/mobileSlice';
import { selectCartItems } from '../../../features/cart/cartSlice';
import CartObj from '../../../features/cart/cartObj';
import { selectMightyDeals, selectMightyDealsLoading } from '../core/mightydealSlice';
import { selectOrderPlannerOrders } from '../../AutoshipPages/core/orderPlannerOrdersSlice';
import OrderObj from '../../../features/orders/orderObj';

export const WaysToSave = () => {
    const navigate = useNavigate();
    const AppURL = useSelector(selectIsMobileRoute);
    const mightyDeals = useSelector(selectMightyDeals);
    const QURLParams = AppURL ? `/?${AppURL}` : '/';
    const AndURLParams = AppURL ? `&${AppURL}` : '';
    const cartItems = useSelector(selectCartItems);
    const getGeneralOptions = useSelector(selectGeneralOptions);
    const isMightyDealsLoading = useSelector(selectMightyDealsLoading);
    const orders: Array<Record<string, any>> = useSelector(selectOrderPlannerOrders);
    const autoshipOrders = orders.filter((order, index, self) => index === self.findIndex((o) => o.id === order.id));
    const cart = useMemo(() => new CartObj(cartItems), [cartItems]);
    const MightyPointsRate = getGeneralOptions?.order_planner_points_multiplier;
    const plannedOrders = autoshipOrders.filter((order: any) => {
        const orderObj = new OrderObj(order);
        return orderObj.data.status === 'autoship' || order.status === 'autoship-onhold';;
    });
    const autoshipRedirect = (plannedOrders && plannedOrders.length > 0) ?
        `/autoship${QURLParams}` : `/autoship?start=true${AndURLParams}`;

    const applyDiscount = () => {
        const pathname = Object.keys(cart?.items)?.length > 0 ? 'checkout' : 'order';
        navigate(`/${pathname}/?coupon-code=${mightyDeals?.coupon_code}${AndURLParams}`);
    };

    const renderSkeleton = (bgClass: any) => (
        <Col xs={12} xl={3} md={6} className='mb-4 position-relative'>
            <div className='new-badge position-absolute top-0 bg-black'>
                <div className={`skeleton skeleton-badge`}></div>
            </div>
            <div className={`${bgClass} border border-2 h-100 d-flex justify-content-center align-items-center flex-column p-4 pb-0 skeleton-wrapper`}>
                <div className='pt-4 text-center w-100'>
                    <div className={`${bgClass === 'bgfirstSkeleton' ? 'skeletonDiscount' : 'skeleton'} skeleton-title`}></div>
                    <div className={`${bgClass === 'bgfirstSkeleton' ? 'skeletonDiscount' : 'skeleton'} skeleton-desc`}></div>
                    <div className={`${bgClass === 'bgfirstSkeleton' ? 'skeletonDiscount' : 'skeleton'} skeleton-button`}></div>
                </div>
            </div>
        </Col>
    );

    return (
        <div className='pt-2 px-2'>
            <div className='fw-500 fs-32px font-poppins mt-2 pt-2 text-center text-uppercase'>Ways To Save</div>
            <Row className='mt-1 d-flex justify-content-center'>
                {isMightyDealsLoading ? (
                    <>
                        {renderSkeleton('bgfirstSkeleton')}
                        {renderSkeleton('bgfirstSkeleton')}
                        {/* {renderSkeleton('bg-red border-red')} */}
                        {renderSkeleton('bgfirstSkeleton')}
                    </>
                ) : (
                    <>
                        <Col xs={12} xl={4} md={4} className='mb-4 position-relative'>
                            <div className="new-badge position-absolute top-0 bg-black">
                                <Badge className="bg-black rounded-0 p-2 px-4 text-uppercase font-glegoo fw-400 fs-16px">REDEEM</Badge>
                            </div>
                            <div className='border border-2 h-100 d-flex justify-content-center align-items-center flex-column p-4 pb-2'>
                                <div className='pt-4'>
                                    <div className='text-uppercase text-center font-league-gothic fw-400 fs-40px lh-1 pb-2'>
                                        <span>Get 1</span><span className='text-success'> FREE</span><br />
                                        <span className='text-uppercase'>MightyMeal</span>
                                    </div>
                                    <div className='font-barlow fw-400 text-center fs-18px lh-24px pb-3'>
                                        for completing your profile so we may better customize your ordering experience.
                                    </div>
                                    <div className='text-center my-3'>
                                        <Button
                                            variant="success"
                                            size="sm"
                                            as={Link as any}
                                            className='text-uppercase'
                                            to={`/my-account/edit-account`}
                                        >
                                            EDIT PROFILE
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        {Object.keys(mightyDeals).length > 0 &&
                            <Col xs={12} xl={4} md={4} className='mb-4 position-relative'>
                                <div className="new-badge position-absolute top-0 bg-black">
                                    <Badge className="bg-black rounded-0 p-2 px-4 text-uppercase font-glegoo fw-400 fs-16px">
                                        {mightyDeals.label}
                                    </Badge>
                                </div>
                                <div className='bg-yellow border border-2 border-yellow h-100 d-flex justify-content-center align-items-center flex-column p-4 pb-0'>
                                    <div className='pt-4'>
                                        <div className='text-uppercase text-center font-league-gothic fw-400 fs-40px lh-1'>
                                            <span className='text-uppercase' dangerouslySetInnerHTML={{ __html: mightyDeals.offer_title }}></span>
                                        </div>
                                        <div className='font-barlow fw-400 text-center fs-18px pt-3 lh-24px pb-2' dangerouslySetInnerHTML={{ __html: mightyDeals.offer_desc }}></div>
                                        <div className='text-center my-3'>
                                            <Button
                                                variant="light"
                                                size="sm"
                                                className='text-uppercase'
                                                onClick={applyDiscount}
                                            >
                                                {mightyDeals.button_text}
                                            </Button>
                                        </div>
                                    </div>
                                    <div className='text-center pb-0'>
                                        <span className='font-barlow fw-400 fs-9px'>{mightyDeals.terms_cond_text}</span>
                                    </div>
                                </div>
                            </Col>}
                        {/* <Col xs={12} xl={3} md={3} className='mb-4 position-relative'>
                            <div className="new-badge position-absolute top-0 bg-black">
                                <Badge className="bg-black rounded-0 p-2 px-4 font-glegoo fw-400 fs-16px">REWARDS</Badge>
                            </div>
                            <div className='bg-red border border-2 border-red h-100 d-flex justify-content-center align-items-center flex-column p-3 pb-2'>
                                <div className='pt-4'>
                                    <div className='text-uppercase text-center font-league-gothic fw-400 fs-40px lh-1 pb-2'>
                                        <span className='text-white fs-106px'>+300</span><br />
                                        <span className='text-white text-uppercase'>MIGHTY POINTS</span>
                                    </div>
                                    <div className='font-barlow fw-400 text-center text-white fs-18px lh-24px pb-3'>
                                        For planning your 2nd order!
                                    </div>
                                    <div className='text-center my-3'>
                                        <Button
                                            variant="light"
                                            size="sm"
                                            as={Link as any}
                                            className='text-uppercase'
                                            to={`/my-account/edit-account`}
                                        >
                                            EDIT PROFILE
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Col> */}
                        {MightyPointsRate && Number(MightyPointsRate) > 1 &&
                            <Col xs={12} xl={4} md={4} className='mb-4 position-relative'>
                                <div className="new-badge position-absolute top-0 bg-black">
                                    <Badge className="bg-black rounded-0 p-2 px-4 font-glegoo fw-400 fs-16px">REWARDS</Badge>
                                </div>
                                <div className='bg-success border border-2 border-success h-100 d-flex justify-content-center align-items-center flex-column p-4 pb-0'>
                                    <div className='pt-5'>
                                        <div className='text-uppercase text-center font-league-gothic fw-400 fs-40px lh-1 pb-2'>
                                            <span className='text-uppercase'>{Number(MightyPointsRate)}X POINTS</span><br />
                                            <span className='text-uppercase'>WITH ORDER PLANNER</span>
                                        </div>
                                        <div className='font-barlow fw-400 text-center fs-18px lh-24px pb-3'>
                                            Earn <span className='fw-bold'>{Number(MightyPointsRate)}X POINTS</span> for every order placed with the Order Planner.
                                        </div>
                                        <div className='text-center my-3'>
                                            <Button
                                                variant="light"
                                                size="sm"
                                                as={Link as any}
                                                className='w-40 text-uppercase font-barlow fw-500 text-center fs-16px'
                                                to={autoshipRedirect}
                                            >
                                                Activate
                                            </Button>
                                        </div>
                                    </div>
                                    <div className='text-center pb-0'>
                                        <span className='font-barlow fw-400 fs-9px'>Terms and Conditions Apply.</span>
                                    </div>
                                </div>
                            </Col>}
                    </>
                )}
            </Row>
            <MightyBucksGiftCardPage />
        </div>
    );
};
